import type { FactionId, Language } from "../core/types";
import { BALANCE } from "../core/data";
export const TEXT: Record<string, [string, string]> = {
  tagline: [
    "Six civilizations. One unclaimed expanse.",
    "Sechs Zivilisationen. Eine unerforschte Weite.",
  ],
  civilizations: ["civilizations", "Zivilisationen"],
  new: ["New campaign", "Neue Kampagne"],
  continue: ["Continue", "Fortsetzen"],
  start: ["Launch campaign", "Kampagne starten"],
  load: ["Load", "Laden"],
  save: ["Save", "Speichern"],
  saves: ["Save & load", "Speichern & Laden"],
  settings: ["Settings", "Einstellungen"],
  help: ["Field manual", "Handbuch"],
  credits: ["Credits", "Mitwirkende"],
  close: ["Close", "Schließen"],
  back: ["Back", "Zurück"],
  cancel: ["Cancel", "Abbrechen"],
  confirm: ["Confirm", "Bestätigen"],
  yes: ["Yes", "Ja"],
  no: ["No", "Nein"],
  language: ["Language", "Sprache"],
  "fleet.travel": ["Fleet in transit", "Flotte im Anflug"],
  "sound.enable": ["Enable sound", "Ton aktivieren"],
  "sound.enabled": ["Sound enabled", "Ton aktiviert"],
  "sound.blocked": [
    "Your browser requires an interaction to start audio. Click or press a key to begin.",
    "Dein Browser startet Ton erst nach einer Interaktion. Ein Klick oder Tastendruck genügt.",
  ],
  choose: ["Choose your civilization", "Wähle deine Zivilisation"],
  doctrine: ["Fleet doctrine", "Flottendoktrin"],
  home: ["Homeworld", "Heimatwelt"],
  bonus: ["Civilization traits", "Fraktionseigenschaften"],
  preferred: ["Preferred doctrine", "Bevorzugte Doktrin"],
  commander: ["Commander", "Kommandant"],
  role: ["Doctrine", "Doktrin"],
  setup: ["Campaign parameters", "Kampagneneinstellungen"],
  opponents: ["Opponents", "Gegner"],
  difficulty: ["Difficulty", "Schwierigkeit"],
  easy: ["Easy", "Leicht"],
  normal: ["Normal", "Normal"],
  hard: ["Hard", "Schwer"],
  seed: ["Galaxy seed", "Galaxie-Seed"],
  "seed.hint": [
    "A fresh galaxy is generated for every campaign. Enter a seed to replay a map.",
    "Jede Kampagne erzeugt eine neue Galaxie. Mit einem Seed lässt sich eine Karte wiederholen.",
  ],
  tutorial: ["Guided introduction", "Geführter Einstieg"],
  "launch.hint": [
    "Begin with 260 C, a scout, a cruiser and a level-I bastion.",
    "Du beginnst mit 260 C, einem Scout, einem Kreuzer und einer Bastion I.",
  ],
  vanguard: ["Vanguard", "Vorhut"],
  guardian: ["Guardian", "Wächter"],
  navigator: ["Navigator", "Navigator"],
  "vanguard.desc": [
    "+5% attack per rank. One system jump at rank I.",
    "+5 % Angriff je Rang. Ein Systemsprung auf Rang I.",
  ],
  "guardian.desc": [
    "+5% damage resistance per rank. One system jump at rank I.",
    "+5 % Schadensresistenz je Rang. Ein Systemsprung auf Rang I.",
  ],
  "navigator.desc": [
    "Two starting jumps; attack and resistance rise from rank II.",
    "Zwei Startsprünge; Angriff und Resistenz steigen ab Rang II.",
  ],
  "doctrine.hint": [
    "At ranks III and V, gain one extra jump, up to four. Preferred doctrine adds 3 percentage points to its combat bonuses.",
    "Auf Rang III und V je ein weiterer Sprung, bis maximal vier. Die bevorzugte Doktrin erhält 3 Prozentpunkte auf ihre Kampfboni.",
  ],
  map: ["Star chart", "Sternenkarte"],
  region: ["The Meridian Expanse", "Die Meridian-Weite"],
  turn: ["Turn", "Runde"],
  end: ["End turn", "Runde beenden"],
  "end.confirm": [
    "End your turn and hand command to the rival civilizations?",
    "Deine Runde beenden und das Kommando an die Gegner übergeben?",
  ],
  "enemy.turn": ["Rival command in progress", "Gegner führen ihre Befehle aus"],
  income: ["Base income", "Grundeinkommen"],
  net: ["Net / turn", "Netto / Runde"],
  upkeep: ["Fleet upkeep", "Flottenunterhalt"],
  rp: ["Research", "Forschung"],
  charge: ["Anomaly charge", "Anomalieenergie"],
  fleets: ["Fleets", "Flotten"],
  systems: ["Systems", "Systeme"],
  "capital.goal": [
    "Capture every active rival homeworld. Protect your own.",
    "Erobere alle aktiven gegnerischen Heimatwelten. Schütze deine eigene.",
  ],
  "neutral.owner": ["Independent", "Unabhängig"],
  unknown: ["Unknown", "Unbekannt"],
  uncharted: ["Uncharted system", "Unerforschtes System"],
  fog: ["Sensor contact", "Sensorkontakt"],
  stale: ["Last known contact", "Letzter bekannter Kontakt"],
  charted: [
    "Charted; no current sensor contact",
    "Kartiert; kein aktueller Sensorkontakt",
  ],
  seen: ["Last observed turn", "Zuletzt beobachtet: Runde"],
  owner: ["Control", "Kontrolle"],
  stars: ["Star rating", "Sternenstufe"],
  "select.system": [
    "Select a system to inspect it.",
    "Wähle ein System für die Details.",
  ],
  "select.fleet": ["Select a fleet", "Flotte wählen"],
  move: ["Jump to system", "Zum System springen"],
  attack: ["Engage system", "System angreifen"],
  moves: ["Jumps left", "Verbleibende Sprünge"],
  "zoom.in": ["Zoom in", "Vergrößern"],
  "zoom.out": ["Zoom out", "Verkleinern"],
  center: ["Center chart", "Karte zentrieren"],
  "zoom.hint": [
    "Drag / arrows / WASD: pan · Wheel / + / −: zoom",
    "Ziehen / Pfeile / WASD: verschieben · Mausrad / + / −: Zoom",
  ],
  "enemy.info": [
    "Exact forces are available only inside your sensor range.",
    "Genaue Streitkräfte werden nur in deiner Sensorreichweite angezeigt.",
  ],
  reserves: [
    "One fleet fights per engagement. Additional fleets remain in reserve and cannot reinforce mid-battle.",
    "Pro Gefecht kämpft eine Flotte. Weitere Flotten bleiben in Reserve und können nicht während des Kampfes eingreifen.",
  ],
  build: ["Construct / upgrade", "Bauen / ausbauen"],
  level: ["Level", "Stufe"],
  max: ["Maximum level", "Maximale Stufe"],
  mine: ["Mining complex", "Minenkomplex"],
  research: ["Research array", "Forschungsanlage"],
  bastion: ["Bastion", "Bastion"],
  grid: ["Defense grid", "Verteidigungsnetz"],
  economic: ["Economic slot", "Wirtschaftsplatz"],
  military: ["Military slot", "Militärplatz"],
  empty: ["Empty", "Frei"],
  "mine.desc": [
    "+12 / 22 / 35 credits each turn. Uses the economic slot.",
    "+12 / 22 / 35 Credits pro Runde. Belegt den Wirtschaftsplatz.",
  ],
  "research.desc": [
    "+8 / 16 / 28 RP and +4 / 8 / 14 AC each turn. Uses the economic slot.",
    "+8 / 16 / 28 RP und +4 / 8 / 14 AC pro Runde. Belegt den Wirtschaftsplatz.",
  ],
  "bastion.desc": [
    "Defends the system, enables shipbuilding, restores shields and repairs 10 / 22 / 35% hull at your next turn.",
    "Verteidigt das System, erlaubt Schiffsbau, füllt Schilde und repariert 10 / 22 / 35 % Hülle zu deiner nächsten Runde.",
  ],
  "grid.desc": [
    "Each level adds 10% bastion attack and 10 percentage points of damage resistance.",
    "Je Stufe +10 % Bastionsangriff und 10 Prozentpunkte Schadensresistenz.",
  ],
  "construction.limit": [
    "One building order per system per turn.",
    "Ein Gebäudeauftrag je System und Runde.",
  ],
  shipyard: ["Shipyard", "Werft"],
  "build.ship": ["Build ship", "Schiff bauen"],
  scout: ["Scout", "Scout"],
  cruiser: ["Cruiser", "Kreuzer"],
  dreadnought: ["Dreadnought", "Schlachtschiff"],
  hull: ["Hull", "Hülle"],
  shields: ["Shields", "Schilde"],
  damage: ["Attack", "Angriff"],
  accuracy: ["Accuracy", "Trefferchance"],
  "accuracy.hint": [
    "Nominal accuracy before target evasion. Each attack is limited to a 55–98% hit chance.",
    "Nominelle Genauigkeit vor gegnerischem Ausweichen. Die Trefferchance jedes Angriffs liegt zwischen 55 und 98 %.",
  ],
  initiative: ["Initiative", "Initiative"],
  evasion: ["Evasion", "Ausweichen"],
  rank: ["Rank", "Rang"],
  xp: ["Experience", "Erfahrung"],
  commission: ["Commission fleet", "Flotte anwerben"],
  "commission.hint": [
    "Each commander can lead one fleet. A commission includes one scout. Maximum: 3 fleets, 7 ships each.",
    "Jeder Kommandant führt eine Flotte. Eine Anwerbung enthält einen Scout. Maximal: 3 Flotten mit je 7 Schiffen.",
  ],
  "no.fleets": [
    "No fleets remain. Commission a commander at a bastion.",
    "Keine Flotten vorhanden. Wirb einen Kommandanten an einer Bastion an.",
  ],
  technology: ["Technology", "Technologie"],
  weapons: ["Weapons", "Waffen"],
  "shields.tech": ["Shield architecture", "Schildarchitektur"],
  propulsion: ["Propulsion", "Antrieb"],
  infrastructure: ["Infrastructure", "Infrastruktur"],
  "weapons.desc": [
    "Ship attack: +7 / 14 / 21%.",
    "Schiffsangriff: +7 / 14 / 21 %.",
  ],
  "shields.desc": [
    "Maximum ship hull and shields: +6 / 12 / 18%. Existing damage keeps its proportion.",
    "Maximale Hülle und Schilde: +6 / 12 / 18 %. Vorhandener Schaden bleibt anteilig erhalten.",
  ],
  "propulsion.desc": [
    "Accuracy: +4 / 8 / 12 percentage points. Movement depends on the admiral.",
    "Trefferchance: +4 / 8 / 12 Prozentpunkte. Bewegung hängt vom Admiral ab.",
  ],
  "infrastructure.desc": [
    "Ship and building costs: −5 / 10 / 15%.",
    "Schiffs- und Gebäudekosten: −5 / 10 / 15 %.",
  ],
  "preferred.research": [
    "Preferred research: 15% lower RP cost.",
    "Bevorzugte Forschung: 15 % weniger RP-Kosten.",
  ],
  "research.buy": ["Research upgrade", "Verbesserung erforschen"],
  anomalies: ["Anomaly command", "Anomalie-Kommando"],
  "special.hint": [
    "All civilizations can use all six abilities. Spend AC from research arrays; one special action per own turn.",
    "Alle Fraktionen können alle sechs Fähigkeiten nutzen. AC stammen aus Forschungsanlagen; eine Spezialaktion pro eigener Runde.",
  ],
  target: ["Target system", "Zielsystem"],
  repairPulse: ["Repair pulse", "Reparaturimpuls"],
  phaseBarrier: ["Phase barrier", "Phasenbarriere"],
  slipstreamCorridor: ["Slipstream corridor", "Slipstream-Korridor"],
  sabotageProbe: ["Sabotage probe", "Sabotagesonde"],
  ionTempest: ["Ion tempest", "Ionensturm"],
  sensorBurst: ["Sensor burst", "Sensorimpuls"],
  "repairPulse.desc": [
    "Restore 35% maximum hull and all shields to one fleet in a friendly system.",
    "Stellt 35 % maximale Hülle und alle Schilde einer Flotte im eigenen System wieder her.",
  ],
  "phaseBarrier.desc": [
    "Block hostile entry into one friendly system until your next turn begins.",
    "Verhindert feindlichen Eintritt in ein eigenes System bis zum Beginn deiner nächsten Runde.",
  ],
  "slipstreamCorridor.desc": [
    "Move a fleet between friendly charted systems up to three edges apart. Costs one jump.",
    "Versetzt eine Flotte zwischen kartierten eigenen Systemen mit bis zu drei Kanten Abstand. Kostet einen Sprung.",
  ],
  "sabotageProbe.desc": [
    "An adjacent known hostile bastion loses 25% of its current shields in the next battle before your next turn.",
    "Eine benachbarte bekannte feindliche Bastion verliert 25 % ihrer aktuellen Schilde im nächsten Gefecht vor deiner nächsten Runde.",
  ],
  "ionTempest.desc": [
    "Defending ships in an adjacent known hostile system lose 20% of current shields in the next battle before your next turn.",
    "Verteidigende Schiffe eines benachbarten bekannten feindlichen Systems verlieren 20 % ihrer aktuellen Schilde im nächsten Gefecht vor deiner nächsten Runde.",
  ],
  "sensorBurst.desc": [
    "Reveal the chart and ownership for two own turns. Does not reveal hidden ships.",
    "Enthüllt Karte und Besitz für zwei eigene Runden. Zeigt keine verdeckten Schiffe.",
  ],
  activate: ["Activate", "Aktivieren"],
  ready: ["Ready", "Bereit"],
  used: ["Used this turn", "Diese Runde genutzt"],
  battle: ["Fleet engagement", "Flottengefecht"],
  sim: ["Combat", "Kampf"],
  round: ["Combat round", "Kampfrunde"],
  attacker: ["Attacker", "Angreifer"],
  defender: ["Defender", "Verteidiger"],
  offensive: ["Offensive", "Offensiv"],
  neutral: ["Neutral", "Neutral"],
  defensive: ["Defensive", "Defensiv"],
  "offensive.desc": [
    "120% attack · 115% incoming damage · prioritize threats and weak targets",
    "120 % Angriff · 115 % erlittener Schaden · bevorzugt gefährliche und schwache Ziele",
  ],
  "neutral.desc": [
    "100% attack · 100% incoming damage · focus damaged units",
    "100 % Angriff · 100 % erlittener Schaden · konzentriert beschädigte Einheiten",
  ],
  "defensive.desc": [
    "85% attack · 80% incoming damage · prioritize valuable healthy threats",
    "85 % Angriff · 80 % erlittener Schaden · bevorzugt wertvolle gesunde Bedrohungen",
  ],
  next: ["Next round", "Nächste Runde"],
  auto: ["Auto", "Auto"],
  pause: ["Pause", "Pause"],
  skip: ["Skip animations", "Animationen überspringen"],
  retreat: ["Retreat", "Rückzug"],
  "retreat.confirm": [
    "Retreat to the origin system? Surviving defenders fire a final salvo at half damage.",
    "Zum Startsystem zurückziehen? Überlebende Verteidiger feuern eine letzte Salve mit halbem Schaden.",
  ],
  "retreat.hint": [
    "Attacker only; a friendly adjacent origin system must remain available.",
    "Nur Angreifer; ein eigenes benachbartes Startsystem muss verfügbar sein.",
  ],
  log: ["Combat log", "Kampfprotokoll"],
  hit: ["hit", "trifft"],
  miss: ["misses", "verfehlt"],
  destroy: ["destroyed", "zerstört"],
  "end.battle": ["Engagement resolved", "Gefecht entschieden"],
  "battle.lost": ["Engagement lost", "Gefecht verloren"],
  "battle.won": ["System secured", "System gesichert"],
  "battle.retreat": ["Withdrawal completed", "Rückzug abgeschlossen"],
  "battle.enemy.retreat": [
    "Enemy fleet withdrew",
    "Gegnerische Flotte zurückgezogen",
  ],
  "battle.control": [
    "Choose your stance for the next round. Ships act automatically.",
    "Wähle deine Haltung für die nächste Runde. Schiffe handeln automatisch.",
  ],
  "battle.limit": [
    "At 24 rounds, the defender holds the system.",
    "Nach 24 Runden hält der Verteidiger das System.",
  ],
  report: ["Battle report", "Kampfbericht"],
  reports: ["Command records", "Kommandoprotokolle"],
  losses: ["Ships lost", "Schiffsverluste"],
  "loss.cost": ["Value of losses", "Wert der Verluste"],
  survivors: ["Survivors", "Überlebende"],
  captured: ["System captured", "System erobert"],
  surrender: ["Civilization surrendered", "Zivilisation kapituliert"],
  "empty.report": [
    "No engagements recorded yet.",
    "Noch keine Gefechte verzeichnet.",
  ],
  ledger: ["Turn ledger", "Rundenkonto"],
  summary: ["Turn summary", "Rundenauswertung"],
  supply: ["Supply shortage", "Versorgungsengpass"],
  "supply.hint": [
    "Insufficient credits for upkeep: −10% attack per unpaid turn, up to −30%, until the balance is positive.",
    "Unzureichende Credits für Unterhalt: −10 % Angriff pro unversorgter Runde, bis −30 %, bis der Saldo wieder positiv ist.",
  ],
  victory: ["The expanse is yours", "Die Weite gehört dir"],
  defeat: ["Your homeworld has fallen", "Deine Heimatwelt ist gefallen"],
  "victory.desc": [
    "Every active rival has surrendered. Your civilization now guides the Meridian Expanse.",
    "Alle aktiven Gegner haben kapituliert. Deine Zivilisation führt nun die Meridian-Weite.",
  ],
  "defeat.desc": [
    "The loss of your homeworld ends this campaign. Begin a new expedition with another doctrine.",
    "Der Verlust deiner Heimatwelt beendet diese Kampagne. Beginne eine neue Expedition mit einer anderen Doktrin.",
  ],
  restart: ["New expedition", "Neue Expedition"],
  menu: ["Main menu", "Hauptmenü"],
  "menu.confirm": [
    "Return to the main menu? Save or export first to preserve recent orders.",
    "Zum Hauptmenü zurückkehren? Sichere oder exportiere zuvor die letzten Befehle.",
  ],
  statistics: ["Campaign statistics", "Kampagnenstatistik"],
  manual: ["Manual saves", "Manuelle Spielstände"],
  automatic: ["Autosaves", "Automatische Spielstände"],
  slot: ["Slot", "Platz"],
  name: ["Save name", "Name des Spielstands"],
  "save.ok": ["Game saved.", "Spiel gespeichert."],
  "save.loaded": ["Game restored.", "Spiel wiederhergestellt."],
  "save.failed": [
    "Saving failed. Export a JSON backup to keep your campaign.",
    "Speichern fehlgeschlagen. Exportiere eine JSON-Sicherung deiner Kampagne.",
  ],
  "save.invalid": [
    "Invalid or damaged save. Nothing was overwritten.",
    "Ungültiger oder beschädigter Spielstand. Es wurde nichts überschrieben.",
  ],
  "save.size": [
    "Save exceeds the 5 MB limit.",
    "Der Spielstand überschreitet das Limit von 5 MB.",
  ],
  "save.missing": ["Save not found.", "Spielstand nicht gefunden."],
  "save.overwrite": [
    "Replace this save with the current campaign?",
    "Diesen Spielstand durch die aktuelle Kampagne ersetzen?",
  ],
  "save.load.confirm": [
    "Load this campaign and replace the current unsaved state?",
    "Diese Kampagne laden und den aktuellen ungesicherten Zustand ersetzen?",
  ],
  "save.delete.confirm": [
    "Permanently delete this local save?",
    "Diesen lokalen Spielstand endgültig löschen?",
  ],
  "save.import.confirm": [
    "Import the validated campaign and replace the current unsaved state?",
    "Die geprüfte Kampagne importieren und den aktuellen ungesicherten Zustand ersetzen?",
  ],
  delete: ["Delete", "Löschen"],
  export: ["Export JSON", "JSON exportieren"],
  import: ["Import JSON", "JSON importieren"],
  "save.hint": [
    "Five manual slots and three rotating autosaves. Autosave at your turn start and after resolved battles. Export a backup before clearing browser data.",
    "Fünf manuelle Plätze und drei rotierende Autosaves. Automatisch zu Beginn deiner Runde und nach Gefechten. Exportiere eine Sicherung, bevor du Browserdaten löschst.",
  ],
  "storage.memory": [
    "Persistent storage is unavailable. Saves last only in this tab; export a backup.",
    "Dauerhafter Speicher ist nicht verfügbar. Spielstände bestehen nur in diesem Tab; exportiere eine Sicherung.",
  ],
  "storage.local": [
    "Using browser local storage as an IndexedDB fallback.",
    "Lokaler Browserspeicher ersetzt die nicht verfügbare IndexedDB.",
  ],
  master: ["Master volume", "Gesamtlautstärke"],
  music: ["Music volume", "Musiklautstärke"],
  sfx: ["Effects volume", "Effektlautstärke"],
  mute: ["Mute", "Stumm"],
  motion: ["Reduce motion", "Bewegung reduzieren"],
  contrast: ["High contrast", "Hoher Kontrast"],
  speed: ["Animation speed", "Animationsgeschwindigkeit"],
  fullscreen: ["Fullscreen", "Vollbild"],
  "fullscreen.fail": [
    "Fullscreen is unavailable in this browser.",
    "Vollbild ist in diesem Browser nicht verfügbar.",
  ],
  notice: ["Command notification", "Kommandonachricht"],
  "help.goal": [
    "Capture enemy homeworlds to force surrender; losing your own ends the campaign. Neutral defenses increase with the star rating.",
    "Erobere gegnerische Heimatwelten für ihre Kapitulation; verlierst du deine eigene, endet die Kampagne. Neutrale Verteidigung wächst mit der Sternenstufe.",
  ],
  "help.economy": [
    "Income and upkeep settle at your turn start. One economic slot holds a mine OR a research array. Construct a bastion to build ships and repair.",
    "Einkommen und Unterhalt werden zu Rundenbeginn verrechnet. Ein Wirtschaftsplatz enthält Mine ODER Forschungsanlage. Eine Bastion ermöglicht Schiffsbau und Reparatur.",
  ],
  "help.fog": [
    "Ships scan one edge, Greys two. Bastions scan one. Old contacts retain last known ownership, never current hidden forces.",
    "Schiffe scannen eine Kante, Graue zwei. Bastionen scannen eine. Alte Kontakte behalten den letzten Besitz, zeigen aber keine aktuellen verdeckten Kräfte.",
  ],
  "help.core": [
    "Six core systems connect the sectors. Prism Relay reveals the chart; Null Observatory scans two edges.",
    "Sechs Kernsysteme verbinden die Sektoren. Prism Relay enthüllt die Karte; Null Observatory scannt zwei Kanten.",
  ],
  "help.battle": [
    "Initiative decides firing order. Shields absorb damage before hull; destroyed ships cannot fire. Change stance before each round. Retreat requires an adjacent friendly origin.",
    "Initiative bestimmt die Schussfolge. Schilde absorbieren Schaden vor der Hülle; zerstörte Schiffe feuern nicht mehr. Wähle die Haltung vor jeder Runde. Rückzug erfordert ein benachbartes eigenes Startsystem.",
  ],
  "help.keys": [
    "Tab + Enter / Space: activate · Esc: close · Arrows / WASD: pan chart · E: end turn · 1/2/3: stance · Space: next round · A: auto · R: retreat · +/−: zoom · H: home",
    "Tab + Enter / Leertaste: aktivieren · Esc: schließen · Pfeile / WASD: Karte verschieben · E: Runde beenden · 1/2/3: Haltung · Leertaste: Kampfrunde · A: Auto · R: Rückzug · +/−: Zoom · H: Heimat",
  ],
  "help.original": [
    "Original civilizations, ships, worlds and music. This is an independent strategy game with simulated fleet combat.",
    "Eigene Zivilisationen, Schiffe, Welten und Musik. Ein eigenständiges Strategiespiel mit simulierten Flottenkämpfen.",
  ],
  "credits.text": [
    "Game design, programming, procedural worlds and original composition: Stellar Empire production. Civilization and ship illustrations created with OpenAI image generation. Full methods, sources and rights notes accompany the source archive.",
    "Spieldesign, Programmierung, prozedurale Welten und Originalkomposition: Stellar-Empire-Produktion. Fraktions- und Schiffsbilder mit OpenAI-Bildgenerierung erstellt. Methoden, Quellen und Rechtehinweise im Quellarchiv.",
  ],
  "tutorial.0": [
    "Welcome, Commander. Your homeworld must survive. Select your fleet in the dock below the chart.",
    "Willkommen, Kommandant. Deine Heimatwelt muss überleben. Wähle deine Flotte im Dock unter der Karte.",
  ],
  "tutorial.1": [
    "Build a ship at your home bastion. Your first 260 C can fund a cruiser and a mine.",
    "Baue ein Schiff an deiner Heimatbastion. Deine ersten 260 C reichen für einen Kreuzer und eine Mine.",
  ],
  "tutorial.2": [
    "Select an adjacent independent system. Review its sensor contact, then engage when your fleet is ready.",
    "Wähle ein benachbartes unabhängiges System. Prüfe den Sensorkontakt und greife mit bereiter Flotte an.",
  ],
  "tutorial.3": [
    "During combat, select a stance and advance one round. Auto and Skip use exactly the same simulator.",
    "Wähle im Kampf eine Haltung und berechne eine Runde. Auto und Überspringen verwenden denselben Simulator.",
  ],
  "tutorial.4": [
    "Build research arrays in captured systems to unlock technologies and anomalies. End your turn to receive income and repairs.",
    "Baue Forschungsanlagen in eroberten Systemen für Technologien und Anomalien. Beende die Runde für Einkommen und Reparatur.",
  ],
  "tutorial.next": ["Next tip", "Nächster Tipp"],
  "tutorial.dismiss": ["Dismiss guide", "Einführung schließen"],
  "error.credits": ["Not enough credits.", "Nicht genug Credits."],
  "error.rp": ["Not enough research points.", "Nicht genug Forschungspunkte."],
  "error.charge": [
    "Not enough anomaly charge.",
    "Nicht genug Anomalieenergie.",
  ],
  "error.fleet": [
    "Select a valid friendly fleet.",
    "Wähle eine gültige eigene Flotte.",
  ],
  "error.phase": [
    "This order is unavailable in the current phase.",
    "Dieser Befehl ist in der aktuellen Phase nicht verfügbar.",
  ],
  "error.ownSystem": [
    "Select a system you control.",
    "Wähle ein eigenes System.",
  ],
  "error.buildTurn": [
    "A building order was already completed here this turn.",
    "Hier wurde diese Runde bereits ein Gebäudeauftrag ausgeführt.",
  ],
  "error.maxLevel": ["Maximum level reached.", "Maximale Stufe erreicht."],
  "error.economicSlot": [
    "The economic slot is already occupied by the other building type.",
    "Der Wirtschaftsplatz ist bereits mit dem anderen Gebäudetyp belegt.",
  ],
  "error.bastion": [
    "An operational friendly bastion is required.",
    "Eine einsatzbereite eigene Bastion ist erforderlich.",
  ],
  "error.sevenShips": [
    "A fleet can contain at most seven ships.",
    "Eine Flotte kann höchstens sieben Schiffe enthalten.",
  ],
  "error.threeFleets": [
    "A civilization can command at most three fleets.",
    "Eine Zivilisation kann höchstens drei Flotten führen.",
  ],
  "error.commander": [
    "This commander already leads a fleet.",
    "Dieser Kommandant führt bereits eine Flotte.",
  ],
  "error.moves": [
    "No jump budget remains for this order.",
    "Für diesen Befehl verbleibt kein Sprungbudget.",
  ],
  "error.neighbor": [
    "Only adjacent systems can be reached by a normal jump.",
    "Ein normaler Sprung erreicht nur benachbarte Systeme.",
  ],
  "error.barrier": [
    "An active phase barrier blocks entry.",
    "Eine aktive Phasenbarriere verhindert den Eintritt.",
  ],
  "error.specialUsed": [
    "A special action was already used this turn.",
    "Diese Runde wurde bereits eine Spezialaktion genutzt.",
  ],
  "error.ownFleet": [
    "The target fleet must be in a friendly system.",
    "Die Zielflotte muss in einem eigenen System stehen.",
  ],
  "error.corridor": [
    "Choose two distinct friendly charted systems up to three edges apart.",
    "Wähle zwei verschiedene kartierte eigene Systeme mit bis zu drei Kanten Abstand.",
  ],
  "error.adjacentEnemy": [
    "Choose a known hostile or independent system adjacent to your territory.",
    "Wähle ein bekanntes feindliches oder unabhängiges System neben deinem Gebiet.",
  ],
  "error.retreat": [
    "Retreat is available only to the attacker with a friendly adjacent origin.",
    "Rückzug ist nur dem Angreifer mit eigenem benachbartem Startsystem möglich.",
  ],
  "ledger.income": ["System income", "Systemeinkommen"],
  "ledger.mineIncome": ["Mining income", "Mineneinkommen"],
  "ledger.upkeep": ["Fleet upkeep", "Flottenunterhalt"],
  "ledger.researchIncome": ["Research income", "Forschungsertrag"],
  "ledger.chargeIncome": ["Anomaly generation", "Anomalieerzeugung"],
  "ledger.repair": ["Hull repaired", "Hülle repariert"],
  "ledger.shieldRestore": ["Shields restored", "Schilde erneuert"],
  "ledger.capture": ["System captured", "System erobert"],
  "ledger.lostSystem": ["System lost", "System verloren"],
  "ledger.surrender": ["Civilization surrendered", "Zivilisation kapituliert"],
  "ledger.move": ["Fleet jump", "Flottensprung"],
  "ledger.rivalMove": ["Visible rival movement", "Sichtbare Gegnerbewegung"],
  "ledger.battle": ["Engagement resolved", "Gefecht entschieden"],
  "ledger.technology": ["Technology researched", "Technologie erforscht"],
  "ledger.ship": ["Ship commissioned", "Schiff gebaut"],
  "ledger.commission": ["Fleet commissioned", "Flotte angeworben"],
};
export function t(
  language: Language,
  key: string,
  variables: Record<string, string | number> = {},
) {
  let value = TEXT[key]?.[language === "de" ? 1 : 0] ?? key;
  for (const [k, v] of Object.entries(variables))
    value = value.replaceAll(`{${k}}`, String(v));
  return value;
}
export const factionName = (l: Language, f: FactionId) =>
  BALANCE.factions[f].name[l];
export const LORE: Record<FactionId, [string, string]> = {
  alliance: [
    "The Alliance was born when humanity learned to share its future with the machines it created. Its cities rise above the silver oceans of Astraea Prime. Human and cyborg captains debate every expedition, then stand together when the order is given. Their engineers turn patient inquiry into resilient technology. They seek a common horizon, but the expanse will test what unity costs.",
    "Die Allianz entstand, als die Menschheit ihre Zukunft mit den von ihr geschaffenen Maschinen teilte. Ihre Städte erheben sich über den silbernen Ozeanen von Astraea Prime. Menschen und Cyborgs beraten jede Expedition und stehen nach dem Befehl zusammen. Ihre Ingenieure machen aus geduldiger Forschung widerstandsfähige Technik. Sie suchen einen gemeinsamen Horizont, doch die Weite prüft den Preis ihrer Einheit.",
  ],
  greys: [
    "The Greys listen to signals that other civilizations call silence. Beneath the violet skies of Vyr Null, memory is shared through intricate neural rituals. Their vessels bend light around quiet, asymmetrical frames. Scouts go farther and return with questions rather than trophies. To them, conquest begins with knowing where everyone else is looking.",
    "Die Grauen lauschen Signalen, die andere Zivilisationen für Stille halten. Unter dem violetten Himmel von Vyr Null teilen sie Erinnerungen durch komplexe neuronale Rituale. Ihre Schiffe lenken Licht um leise, asymmetrische Körper. Scouts dringen weiter vor und kehren mit Fragen statt Trophäen zurück. Für sie beginnt Eroberung mit dem Wissen, wohin alle anderen blicken.",
  ],
  reptiloids: [
    "Karessa forged the Reptiloids beneath copper storms and emerald canopies. Their clans measure a leader by the burdens carried into battle. Segmented warships combine living curves with industrial armor. Their weapons strike fiercely, though the economy pays for that devotion. An oath offered freely is treasured; an oath forced upon them is never forgotten.",
    "Karessa formte die Reptiloiden unter kupfernen Stürmen und smaragdgrünen Baumkronen. Ihre Clans messen Anführer an der Last, die sie in die Schlacht tragen. Segmentierte Kriegsschiffe vereinen lebendige Kurven mit industrieller Panzerung. Ihre Waffen treffen hart, doch die Wirtschaft bezahlt diese Hingabe. Ein freiwilliger Eid ist kostbar; ein erzwungener Eid bleibt unvergessen.",
  ],
  okalani: [
    "The Okalani first mapped the stars from the dark waters of Thalassa Deep. Reef archives preserve their history in living patterns of light. Their ships shelter crews within luminous, layered shields. Recovery and endurance shape every command decision. They enter the expanse seeking safe currents for a civilization that remembers every lost voice.",
    "Die Okalani kartierten die Sterne zuerst aus den dunklen Gewässern von Thalassa Deep. Riffarchive bewahren ihre Geschichte in lebenden Lichtmustern. Ihre Schiffe schützen Besatzungen hinter leuchtenden, geschichteten Schilden. Erholung und Ausdauer prägen jeden Befehl. Sie suchen sichere Strömungen für eine Zivilisation, die sich an jede verlorene Stimme erinnert.",
  ],
  xilur: [
    "The Xilur Dynasty charts its future from the terraced citadels of Xilur Throne. A ruler is bound to protect the inheritance of generations yet unborn. Golden fortresses and purple banners accompany their measured expansion. Their bastions are formidable and economical to raise. Beyond the homeworld, each new system becomes a promise the dynasty must defend.",
    "Die Xilur-Dynastie entwirft ihre Zukunft in den terrassierten Zitadellen von Xilur Throne. Herrscher müssen das Erbe noch ungeborener Generationen schützen. Goldene Festungen und purpurne Banner begleiten ihre geordnete Expansion. Ihre Bastionen sind stark und günstig zu errichten. Jedes neue System wird zu einem Versprechen, das die Dynastie verteidigen muss.",
  ],
  nocturn: [
    "On Nox Umbra, life evolved without the comfort of a sunlit sky. The Nocturn read heat and resonance as others read color. Their obsidian ships carry vast reserves behind deceptively quiet silhouettes. Dreadnoughts endure punishment while nebulae shelter a devastating first strike. They do not fear the dark between the stars; they recognize it as home.",
    "Auf Nox Umbra entwickelte sich Leben ohne den Trost eines sonnenhellen Himmels. Die Nocturn lesen Wärme und Resonanz wie andere Farben. Ihre Obsidianschiffe tragen große Reserven hinter täuschend stillen Silhouetten. Schlachtschiffe ertragen schwere Treffer, während Nebel einen vernichtenden ersten Schlag verbergen. Die Dunkelheit zwischen den Sternen fürchten sie nicht; sie erkennen darin ihre Heimat.",
  ],
};
export const BONUSES: Record<FactionId, [string, string]> = {
  alliance: ["+10% research income", "+10 % Forschungsertrag"],
  greys: [
    "Fleet sensor range 2 · Scout evasion ×1.10",
    "Flottensensorreichweite 2 · Scout-Ausweichen ×1,10",
  ],
  reptiloids: [
    "+6% ship attack · −5% base income",
    "+6 % Schiffsangriff · −5 % Grundeinkommen",
  ],
  okalani: [
    "+15% maximum shields · Hull repair ×1.10",
    "+15 % maximale Schilde · Hüllenreparatur ×1,10",
  ],
  xilur: [
    "+15% bastion hull · −10% bastion cost",
    "+15 % Bastionshülle · −10 % Bastionskosten",
  ],
  nocturn: [
    "+15% dreadnought hull · +12% on the first successful nebula hit",
    "+15 % Schlachtschiffhülle · +12 % beim ersten erfolgreichen Nebeltreffer",
  ],
};
